import styled from 'styled-components';

const HeaderBar = styled.div`
  display: flex;
  align-items: center;

  .headerInputsContainer {
    margin-right: 10px;
  }
`;

const ContainerPills = styled.div`
  .cardHeaderRight {
    margin-left: 40px;
    width: 100%;
    justify-content: flex-end;
  }

  .headerBar {
    display: flex;
  }

  .rightComponentsContainer {
    display: flex;
    flex-direction: row;
    width: 100%;
    align-items: center;

    > div:not(:last-child) {
      margin-right: 10px;
    }
  }
`;

const HeaderRightComponents = styled.div`
  display: flex;
  flex-direction: row;
  .linkContainer {
    display: flex;
    text-decoration: none;
  }
  .prepareMyTrip {
    display: inline-flex;
    align-items: center;
    margin-left: 5px;
    text-decoration: none;
    p {
      display: none;
    }

    :hover {
      p {
        display: block;
      }
    }
  }

  @media (max-width: ${(props) =>
      props.theme.devices.isTablet ? '0px' : '845px'}) {
    margin-top: 10px;
    margin-left: 0px;
  }

  align-items: center;
  font-family: ${(props) => props.theme.fonts.sfcompact_text};

  .labelCheckbox {
    margin-left: 9px;
    margin-right: 15px;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-size: 12px;
    color: ${(props) => props.theme.colors['dark-two']};
  }

  .localisationIcon {
    margin-left: 10px;
  }

  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }
`;

const VintageTooltip = styled.div`
  min-width: 230px;
  padding: 15px;
  display: flex;
  flex-direction: column;

  .rowVintageTooltip {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .rowVintageTooltip > p {
    color: #abb5be;
  }

  .rowVintageTooltip p {
    font-family: ${(props) => props.theme.fonts.sfcompact};
  }

  .rowVintageTooltip > div {
    margin-left: auto;
  }
`;

export { HeaderBar, ContainerPills, HeaderRightComponents, VintageTooltip };
